var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "11px",
    viewBox: "0 0 21 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "expand-up",
    transform: "translate(10.048986, 5.145824) scale(1, -1) translate(-10.048986, -5.145824) translate(-0.000025, -0.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.482036,6.58819924 C10.689159,7.37720524 9.40847602,7.37720524 8.61559802,6.58819924 L8.61559802,6.58974824 L2.46383002,0.437205235 C1.91408102,-0.131901765 1.00660802,-0.147387765 0.437501025,0.402361235 C-0.131604975,0.952110235 -0.147864975,1.85958324 0.402658025,2.42869024 C0.413498025,2.44030424 0.425887025,2.45269324 0.437501025,2.46353324 L7.00971202,9.03729224 C8.69070502,10.7097682 11.407704,10.7097682 13.088697,9.03729224 L19.660133,2.46508224 C20.230014,1.91533324 20.2455,1.00863424 19.695751,0.438753235 C19.146002,-0.130352765 18.238529,-0.145838765 17.669422,0.403910235 C17.657808,0.415524235 17.645419,0.427139235 17.633805,0.438753235 L11.482036,6.58819924 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandUp);
export default __webpack_public_path__ + "static/media/expand-up.06dfe79f.svg";
export { ForwardRef as ReactComponent };